import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpResponse
} from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { config } from 'src/app/config/config';
import { environment } from 'src/environments/environment';

export interface HttpResponseData {
  httpResponse: HttpResponse<any>,
  catchedTimeInMilliSec: number
}

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {

  config: any = config;
  constructor() { }

  private cache = new Map<string, HttpResponseData>();
  private endPointsToCache = new Map<string, number>([
    [environment.URL + this.config.URL.getAllMembers, 600000],

  ]);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let options = {};

    if (request.url.includes('security/validateUser')) {
      options = {
        reportProgress: true,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        })
      };
    }

    if (!request.url.includes(this.config.URL.logoutURL)) {
      if (this.config.data.fileUploadURL.some(url => request.url.includes(url))) {
        options = {
          reportProgress: true,
          headers: new HttpHeaders({
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          })
        };
      } else {
        options = {
          reportProgress: true,
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          })
        };
      }
    }


    let updatedRequest = request.clone(options);

    let httpResponseDataToCache = {
      catchedTimeInMilliSec: 0,
      httpResponse: new HttpResponse()
    }

    if (this.endPointsToCache.has(request.url)) {
      const catchedTimeInMilliSecValue = this.endPointsToCache.get(request.url);
      if (this.cache.has(request.url)) {
        const httpResponseDataToCache = this.cache.get(request.url);
        if (catchedTimeInMilliSecValue > 0 && (Date.now() - httpResponseDataToCache.catchedTimeInMilliSec) > catchedTimeInMilliSecValue) {
          this.cache.delete(request.url);
        }
        else {
          if (httpResponseDataToCache.httpResponse) {
            return of(httpResponseDataToCache.httpResponse);
          }
        }
      }

      return next.handle(updatedRequest).pipe(
        tap((response) => {
          if (response instanceof HttpResponse) {
            httpResponseDataToCache.httpResponse = response;
            httpResponseDataToCache.catchedTimeInMilliSec = Date.now();
            this.cache.set(request.url, httpResponseDataToCache);
          }
        })
      );
    }

    return next.handle(updatedRequest);
  }
}
